module.exports = __webpack_public_path__ + "static/media/dennis.2698799c.png";